export const statBonuses = {
  Dragonborn: ["Strength +2", "Charisma +1"],
  Dwarf: ["Strength +2", "Constitution +2", "Wisdom +1"],
  Elf: ["Dexterity +2", "Wisdom +1"],
  Gnome: ["Dexterity +1", "Constitution +1", "Intelligence +2"],
  "Half-Elf": ["Charisma +2"],
  "Half-Orc": ["Strength +2", "Constitution +1"],
  Halfling: ["Dexterity +2", "Constitution +1", "Charisma +1"],
  Human: [
    "Strength +1",
    "Dexterity +1",
    "Constitution +1",
    "Intelligence +1",
    "Wisdom +1",
    "Charisma +1",
  ],
  Tiefling: ["Intelligence +1", "Charisma +2"],
};
